import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { observer, inject } from "mobx-react";
import images from "Configs/images.config";
import { replaceStaticHost } from "Helpers/ImageManager";
import withDefaultParams from "Services/withDefaultParams";
import { sendMetriks } from "Services/sendMetriks";
import HeaderContainer from "Containers/HeaderContainer";
import AddressSearchContainer from "Containers/AddressSearchContainer";
import ProfitableTariffsCarousel from "Containers/ProfitableTariffsCarousel";
import { PageTitle404, PageTitle404Header } from "ComponentsUI/Components404";
import loadable from "@loadable/component";

const OurModalAgreement = loadable(() => import("ComponentsUI/OurModalAgreement"), {
	ssr: false,
});

const Header404 = (props) => {
	let {
		ApplicationModel: {
			windowSizeModel: { windowSizes },
			currentRegion,
			text,
		},
	} = props;
	useEffect(() => {
		sendMetriks("PAGE_NOT_FOUND");
	}, []);

	const imagePageTitle =
		!!currentRegion && !!currentRegion.image_lg
			? {
					lg: replaceStaticHost(currentRegion.image_lg),
					md: replaceStaticHost(currentRegion.image_md),
					sm: replaceStaticHost(currentRegion.image_sm),
					xs: replaceStaticHost(currentRegion.image_xs),
				}
			: {
					lg: replaceStaticHost(images.heroBannerLg),
					md: replaceStaticHost(images.heroBannerMd),
					sm: replaceStaticHost(images.heroBannerSm),
					xs: replaceStaticHost(images.heroBannerXs),
				};

	const upper = <PageTitle404Header texth1={text.h1_404} />;
	const middle = <AddressSearchContainer is404={true} hideTitle={true} />;
	const bottom = <ProfitableTariffsCarousel />;

	return (
		<div className="__root" key="1">
			<HeaderContainer phone404={true} />
			<PageTitle404
				upper={upper}
				middle={middle}
				bottom={bottom}
				background={imagePageTitle}
				windowSizes={windowSizes}
			/>
			<OurModalAgreement />
		</div>
	);
};

export default withRouter(withDefaultParams(inject("ApplicationModel")(observer(Header404))));
